import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonAnchor, H3, MessageBox, P1, NegativeButton } from '@zooplus/ui-components';
import './self-return-reminder.css';
import { ExperimentationContext, UserTrackingEvents } from '../../context/ExperimentationContext';

type SelfReturnReminderProps = {
  orderId: string;
  onDismiss: () => void;
};

const SelfReturnReminder: React.FC<SelfReturnReminderProps> = ({
  orderId,
  onDismiss: onDismissCallback,
}) => {
  const { t } = useTranslation();
  const title = t('form.self_return_notification.title');
  const info = t('form.self_return_notification.text');
  const orderDetailsLinkLabel = t('form.self_return_notification.link_label');
  const orderDetailsUrl = t('form.self_return_notification.order_details_url', { orderId });
  const moreHelpQuestion = t('form.self_return_notification.more_help_question');
  const moreHelpButton = t('form.self_return_notification.more_help_button');

  const experimentation = useContext(ExperimentationContext);

  const onDismiss = () => {
    experimentation.trackClick(UserTrackingEvents.CF_SELF_RETURN_REMINDER_NEED_MORE_HELP_CLICKED);
    onDismissCallback();
  };

  const onOrderDetailsLinkClicked = () =>
    experimentation.trackClick(
      UserTrackingEvents.CF_SELF_RETURN_REMINDER_ORDER_DETAILS_LINK_CLICKED,
    );

  useEffect(() => {
    experimentation.trackClick(UserTrackingEvents.CF_SELF_RETURN_REMINDER_DISPLAYED);
  }, []);

  return (
    <div className="selfReturnReminder">
      <MessageBox>
        <H3>
          <p>{title}</p>
        </H3>
        <p>{info}</p>
        <ButtonAnchor
          onClick={onOrderDetailsLinkClicked}
          data-testid="selfReturnReminder.orderDetailsLink"
          href={orderDetailsUrl}
          target="_blank">
          {orderDetailsLinkLabel}
        </ButtonAnchor>
      </MessageBox>
      <div className="selfReturnReminder__footer">
        <P1>{moreHelpQuestion}</P1>
        <NegativeButton data-testid="selfReturnReminder.needHelpButton" onClick={onDismiss}>
          {moreHelpButton}
        </NegativeButton>
      </div>
    </div>
  );
};

export default SelfReturnReminder;
